import { useParams } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { ProducerLayout } from '@/components/producer/ProducerLayout';
import { ProducerSectionHeader } from '@/components/producer/ProducerSectionHeader';
import { useProducerById } from '@/hooks/useMyProducers';
import { useProducerAccess } from '@/hooks/useProducerAccess';
import { TranslationsSection } from '@/features/producer-editor/sections/TranslationsSection';

export default function ProducerOversattningar() {
  const { farmId } = useParams<{ farmId: string }>();
  const { producer, isLoading, error } = useProducerById(farmId);
  const { hasCapability } = useProducerAccess(farmId);

  const canEdit = hasCapability('canEditProducerInfo');

  if (isLoading) {
    return (
      <ProducerLayout farmId={farmId ?? ''} title="Översättningar">
        <div className="flex items-center justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </ProducerLayout>
    );
  }

  if (error || !producer) {
    return (
      <ProducerLayout farmId={farmId ?? ''} title="Översättningar">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>Kunde inte ladda gården.</AlertDescription>
        </Alert>
      </ProducerLayout>
    );
  }

  return (
    <ProducerLayout farmId={farmId ?? ''} producerName={producer.name} title="Översättningar">
      <ProducerSectionHeader
        title="Översättningar"
        description="Engelska texter som visas när besökare väljer EN på er sida."
        isReadOnly={!canEdit}
      />

      <TranslationsSection
        producerId={producer.id}
        shortDescription={producer.short_description ?? ''}
        longDescription={producer.description ?? ''}
        foodDescription={(producer as any).food_description ?? null}
      />
    </ProducerLayout>
  );
}
